/* @flow */
import produce from 'immer';
import { message } from 'antd';
import { actionTypes } from './actions';
import { defineServerErrors } from '@/utils/redux';

const {
  FETCH_ENRICHMENTS,
  FETCH_SUCCESS,
  FETCH_FAILED,

  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILED,

  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILED,

  BEFORE_UPLOAD,
  ON_REMOVE_FILE,
  SET_FILE_NAME,
  TABLE_CHANGE,
} = actionTypes;

type State = {
  isFetching: boolean,
  tableOptions: TableT,
  data: any[],
  file: ?any,
  errors: ?Array<string>,
  fileName: string,
  fileList: any[],
};

const initialState = {
  isFetching: false,
  tableOptions: {
    page: 1,
    limit: 10,
    count: 0,
  },
  file: null,
  data: [],
  errors: null,
  fileName: '',
  fileList: [],
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case FETCH_ENRICHMENTS:
        draft.isFetching = true;
        return;
      case FETCH_SUCCESS: {
        const { results, page, limit, count } = action.payload;
        draft.isFetching = false;
        draft.data = results;
        draft.errors = initialState.errors;
        draft.tableOptions = {
          page,
          limit,
          count,
        };
        return;
      }
      case FETCH_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case UPLOAD_FILE:
        draft.isFetching = true;
        return;
      case UPLOAD_FILE_SUCCESS:
        draft.isFetching = false;
        draft.file = action.payload;
        draft.errors = initialState.errors;
        draft.fileName = initialState.fileName;
        draft.fileList = initialState.fileList;
        return;
      case UPLOAD_FILE_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case DELETE_FILE:
        draft.isFetching = true;
        draft.fileName = initialState.fileName;
        return;
      case DELETE_FILE_SUCCESS:
        draft.isFetching = false;
        draft.errors = initialState.errors;
        draft.fileName = initialState.fileName;
        message.success('File deleted successfully');
        return;
      case DELETE_FILE_FAILED:
        draft.isFetching = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case BEFORE_UPLOAD:
        draft.fileList = [action.payload];
        return;
      case ON_REMOVE_FILE:
        draft.fileList = [];
        return;
      case SET_FILE_NAME:
        draft.fileName = action.payload;
        return;
      case TABLE_CHANGE:
        draft.tableOptions = action.payload;
        return;
    }
  });
